var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),(_vm.$route.params.hasOwnProperty('namespace'))?_c('SideBar'):_vm._e(),_c('div',{class:[
        !_vm.$route.params.hasOwnProperty('namespace') && 'noSidebar',
        _vm.isLoading && 'loading'
      ],attrs:{"id":"main"}},[_c('HeaderSection'),_c('router-view',{key:_vm.$route.path})],1),_c('input',{attrs:{"type":"text","value":"","id":"copyText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }